import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { allapiAction } from "../../Redux/common/action";
import moment from "moment";
import { URL } from "../../Redux/common/url";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedinIn, FaHome, FaEnvelope, FaWhatsapp, FaPhone } from "react-icons/fa";
function BlogDetailsPub() {
  const { id } = useParams();

  const navigate = useNavigate();

  const get_blog_category_list = useSelector((state) =>
    state?.allapi?.get_blog_category_list
      ? state?.allapi?.get_blog_category_list
      : []
  );
  const blog_details = useSelector((state) =>
    state?.allapi?.blog_details ? state?.allapi?.blog_details : {}
  );

  console.log(blog_details);

  const get_recent_blog_list = useSelector((state) =>
    state?.allapi?.get_recent_blog_list
      ? state?.allapi?.get_recent_blog_list
      : []
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(allapiAction.getblogcateAllList({}));
    dispatch(allapiAction.getrectentBlog({}));

    return () => {};
  }, []);
  useEffect(() => {
    if (id) {
      dispatch(allapiAction.getBlogDetails({ id }));
    }

    return () => {};
  }, [id]);

  return (
 <div className="blgDtl">

      {/* Banner Section */}
 <div
  className="banner-slider d-flex align-items-center justify-content-center"
  style={{
    backgroundImage: `url(https://creatosoftware.com/public/uploads/news-banner-12.jpg)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "40vh",
    height: "auto",
    color: "#fff",
    textAlign: "center",
    fontWeight: "700",
    boxShadow: "inset 0 0 0 1000px rgba(0,0,0,0.4)",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    padding: "100px 15px 40px 15px", // top padding zyada, bottom thoda
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  }}
>
  <h1 style={{ 
      fontSize: "clamp(1.5rem, 5vw, 3rem)", 
      lineHeight: "1.2", 
      margin: "0" 
  }}>
    {blog_details?.title}
  </h1>
</div>




      {/* Main Content */}
      <div className="blog-one-area py-5" style={{ backgroundColor: "#f2f4f8" }}>
        <div className="container">
          <div className="row gx-5">

            {/* Blog Content */}
            <div className="col-12 col-md-8 mb-4 mb-md-0">
              <div
                className="single-blog bg-white p-3 p-md-4 rounded shadow-lg"
                style={{ borderLeft: "5px solid #000", transition: "all 0.3s" }}
              >
                <img
                  src={URL?.API_BASE_URL + blog_details?.feature_image}
                  alt="News Photo"
                  style={{
                    width: "100%",
                    maxHeight: "60vh",
                    objectFit: "cover",
                    borderRadius: "10px",
                    marginBottom: "20px",
                  }}
                />

                <h3 style={{ fontWeight: "700", color: "#000", marginBottom: "15px" }}>
                  {blog_details?.title}
                </h3>

                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    color: "#555",
                    marginBottom: "20px",
                  }}
                >
                  <li>
                    <i className="fa fa-calendar-o"></i>{" "}
                    {moment(blog_details?.createdAt).format("MMM DD, YYYY")}
                  </li>
                </ul>

                <div
                  className="blog-description"
                  style={{ lineHeight: "1.8", color: "#333", fontSize: "1rem" }}
                  dangerouslySetInnerHTML={{ __html: blog_details?.description }}
                ></div>

                {/* Share Buttons */}
                <div className="share-news mt-4">
                  <h5 style={{ fontWeight: "700", marginBottom: "10px" }}>
                    Share This News
                  </h5>
                  <div className="d-flex flex-wrap gap-2">
                    <a
                      href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                        blog_details?.title + " - " + window.location.href
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: "45px",
                        height: "45px",
                        backgroundColor: "#25D366",
                        color: "#fff",
                      }}
                    >
                      <FaWhatsapp size={22} />
                    </a>

                    <a
                      href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        window.location.href
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: "45px",
                        height: "45px",
                        backgroundColor: "#3b5998",
                        color: "#fff",
                      }}
                    >
                      <FaFacebook size={22} />
                    </a>

                    <a
                      href={`https://www.instagram.com/?url=${encodeURIComponent(
                        window.location.href
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        width: "45px",
                        height: "45px",
                        background:
                          "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)",
                        color: "#fff",
                      }}
                    >
                      <FaInstagram size={22} />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-12 col-md-4">
              <div className="bg-white p-3 rounded shadow-sm">
                <h5 style={{ fontWeight: "700", marginBottom: "15px" }}>RECENT POSTS</h5>
                {get_recent_blog_list &&
                  get_recent_blog_list.map((data, i) => (
                    <div className="d-flex mb-3" key={i}>
                      <img
                        src={URL?.API_BASE_URL + data?.feature_image}
                        alt="recent"
                        style={{
                          width: "80px",
                          height: "80px",
                          objectFit: "cover",
                          borderRadius: "6px",
                          marginRight: "10px",
                        }}
                          onClick={() => {
                    navigate("/blog-details/" + data?.slug);
                  }}
                      />
                      <div>
                        <p className="m-0" style={{ fontWeight: "600", color: "#000" }}   onClick={() => {
                    navigate("/blog-details/" + data?.slug);
                  }}>
                          {data?.title}
                        </p>
                        <p className="m-0" style={{ color: "#555", fontSize: "0.85rem" }}   onClick={() => {
                    navigate("/blog-details/" + data?.slug);
                  }}>
                          {moment(data?.createdAt).format("MMM DD, YYYY")}
                       
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


  );
}

export default BlogDetailsPub;
